module.exports = __webpack_public_path__ + "img/slide2.35123fee.webp";